<!--  -->
<template>
  <!-- <div class='greetings'>

    <div class="crumbs">
      <div class='content'>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/company' }">公司简介</el-breadcrumb-item>
          <el-breadcrumb-item>问候</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class='content'>
      <h1 class="entry-title">问候</h1>
      <div>

２１世紀のあらゆる産業ニーズに応えるべく、 のグローバルエリアネットワークを駆使し、印刷・加工機器関連、重袋・輪転・枚葉製袋機器関連、重包装・軽包装機器関連に於ける全てのエンジニアリングをお届けします。
又、国内外に於いてのサービスネットワーク体制は、常にお客様目線でのメンテナンス提供を心掛ける事により「安心理論」が定着されています。即ち常に五感を研ぎ澄まし、現物・現場を見る、現実を見る・知る・直視することで、更なる改善提案・新規研究開発提案を推し進めて参ります。
企業としての社会的環境の責任を果たしながら、お客様と供に歩み続けます。

      </div>
    </div>
  </div> -->

     <page pageDataUrl="/api/pageData/page_greetings" v-on:paddingData="paddingPageData" :hasbreadcrumbs="true"
        defPageTitle='管理理念'>

        <div class='content'>
            <h1 class="entry-title">企业社会责任</h1>
            <div v-html="html"></div>
        </div>
    </page>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {

      html:""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {

            paddingPageData(data) {
                this.html = data.data
            }},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
</style>